import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { TParam } from '../types';
import { parseDate } from '../../../utils/date';
import { format } from 'date-fns';
import classNames from 'classnames';

export default function QueryParamInput({
  queryParam,
  onChange,
  className,
}: {
  queryParam: TParam;
  className?: string;
  onChange: (value?: string) => void;
}) {
  if (queryParam.type === 'date') {
    return (
      <DatePicker
        className={classNames('input input-bordered w-full', className)}
        selected={parseDate(queryParam.value, 'yyyy-MM-dd')}
        onChange={(date) => {
          const value = date ? format(date, 'yyyy-MM-dd') : '';
          onChange(value);
        }}
        dateFormat='yyyy-MM-dd'
      />
    );
  }

  if (queryParam.type === 'datetime') {
    return (
      <DatePicker
        className={classNames('input input-bordered w-full', className)}
        selected={parseDate(queryParam.value, 'yyyy-MM-dd HH:mm:ss')}
        onChange={(date) => {
          const value = date ? format(date, 'yyyy-MM-dd HH:mm:ss') : '';
          onChange(value);
        }}
        showTimeInput
        dateFormat='yyyy-MM-dd HH:mm:ss'
      />
    );
  }

  if (queryParam.type === 'number') {
    return (
      <input
        className={classNames('input input-bordered', className)}
        value={queryParam.value}
        type='number'
        onChange={(e) => {
          onChange(e.target.value);
        }}
      />
    );
  }

  return (
    <input
      className={classNames('input input-bordered', className)}
      value={queryParam.value}
      type='text'
      onChange={(e) => {
        onChange(e.target.value);
      }}
    />
  );
}
